import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: "formatAddress" })
export class FormatAddressPipe implements PipeTransform {

	constructor(private sanitizer: DomSanitizer) {
	}

	transform(address: any) {
		var format: string = '';
		if (address) {
			if (address.IsLatLongInvalid) {
				format += '<address title="GPS Is Invalid">***';
			} else {
				format += '<address>';
			}
				if (address.Address1 && address.Address1.trim()) {
					format += address.Address1 + '<br />';
				}
			if (address.Address2 && address.Address2.trim()) {
				format += address.Address2 + '<br />';
			}
			if (address.City || address.State || address.ZipCode) {
				format += address.City + ' ' + address.State + ', ' + address.ZipCode;
			}
			format += '</address>';
		}

		return this.sanitizer.bypassSecurityTrustHtml(format);
	}
}
